export function getIconUrl(iconName: string) {
    return `${window.assetUrl}/assets/img/${iconName}.svg`;
}
